// src/components/ScrollManager.jsx

import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const scrollPositions = new Map();

export default function ScrollManager() {
  const location = useLocation();
  const navigationType = useNavigationType(); // "PUSH", "POP", "REPLACE"
  const prevKeyRef = useRef(location.key);

  // Save scroll position before navigating away
  useEffect(() => {
    return () => {
      scrollPositions.set(prevKeyRef.current, window.pageYOffset || 0);
    };
  }, [location]);

  // Scroll behavior after navigation
  useEffect(() => {
    const savedPosition = scrollPositions.get(location.key);

    if (navigationType === "POP" && typeof savedPosition === "number") {
      // Back / forward
      window.scrollTo({ top: savedPosition, behavior: "auto" });
    } else {
      // New navigation
      window.scrollTo({ top: 0, behavior: "auto" });
    }

    // Update stored key
    prevKeyRef.current = location.key;
  }, [location, navigationType]);

  return null;
}
